// extracted by mini-css-extract-plugin
export default {"base-layout":"N8ovH","main-header":"_gHlK","in-page-messages":"OzpP4","main-content":"vJtX6"};